import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/company/order/`;

const addOrderManual = async (formData) => {
    return await axios.post(API_URL + 'manual', formData);
};

const getCompanyOrder = async (month) => {
    return await axios.post(API_URL, month);
};

const getCompanyOrderDetailByOrder = async (orderId) => {
    return await axios.post(API_URL + 'detail' , orderId);
};

const deleteCompanyOrder = async (orderId) => {
    return await axios.delete(API_URL + orderId);
};

export default {
    getCompanyOrder,
    addOrderManual,
    getCompanyOrderDetailByOrder,
    deleteCompanyOrder
};
